export const beforeAfterPairs = [
  {
    id: "kitchen",
    label: "Kitchen",
    caption: "Kitchen deep clean · Sterling, VA",
    before:
      "/images/before-after/Kitchen-Before.webp",
    after:
      "/images/gallery/Kitchen.webp",
  },
  {
    id: "living",
    label: "Living room",
    caption: "Main level reset · Ashburn, VA",
    before:
      "/images/before-after/Living-Room-Before.webp",
    after:
      "/images/gallery/Living-Room-2.webp",
  },
  {
    id: "bathroom",
    label: "Bathroom",
    caption: "Bathroom deep clean · Leesburg, VA",
    before:
      "/images/before-after/Bathroom-Before.webp",
    after:
      "/images/gallery/Deep-Cleaning-2.webp",
  },
];